import { z } from "zod";

export const ListaItensChecklistSchema = z.object({
    idVerificacaoCliente: z.number(),
    idEntregaObraCliente: z.number().optional(),
    idChecklistEntrega: z.number().optional(),
    idItemChecklistEntrega: z.number().optional(),
    idChecklistEntregaAmbiente: z.number().optional(),
    ordem: z.string().optional(),
    descricao: z.string().optional(),
    inspecao1: z.string().optional(),
    inspecao2: z.string().optional(),
    path: z.array(z.string()).optional(),

});

export type ListaItensChecklistForm = z.infer<typeof ListaItensChecklistSchema>;

export const EntregaObraClienteChecklistCadastroSchema = z.object({
    idEntregaObraCliente: z.number(),
    localVistoria: z.string().optional(),
    idFuncionarioInsp: z.number().optional(),
    idFuncionarioReinsp: z.number().optional(),
    dataInspecao: z.coerce.date().optional(),
    dataReinsp: z.coerce.date().optional(),
    status: z.number().default(0),
    analiseVistoria: z.string().optional(),

    listaItensChecklist: z.array(ListaItensChecklistSchema).default([]),

});

export type EntregaObraClienteChecklistCadastroForm = z.infer<typeof EntregaObraClienteChecklistCadastroSchema>;

export const defaultEntregaObraClienteChecklistCadastroForm: Partial<EntregaObraClienteChecklistCadastroForm> = {
    idEntregaObraCliente: undefined,
    localVistoria: undefined,
    idFuncionarioInsp: undefined,
    idFuncionarioReinsp: undefined,
    dataInspecao: undefined,
    dataReinsp: undefined,
    status: 0,
    analiseVistoria: undefined,

    listaItensChecklist: [],
};
